import React, { useEffect, useState } from "react";
import {
  deleteOrder,
  fetchUserOrders,
  selectOrders,
  selectOrdersError,
  selectOrdersLoading,
} from "../../../redux/slices/ordersSlice";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import MiniLoader from "../../Loader/MiniLoader";
import { useTranslation } from "react-i18next";

const MyOrders = () => {
  const dispatch = useDispatch();
  const orders = useSelector(selectOrders);
  const loading = useSelector(selectOrdersLoading);
  const error = useSelector(selectOrdersError);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const statusLabels = {
    0: t("pending"),
    1: t("delivered"),
    2: t("refunded"),
    3: t("cancelled"),
    4: t("outForDelivery"),
    5: t("accepted"),
    6: t("rejected"),
  };
  useEffect(() => {
    dispatch(fetchUserOrders());
  }, [dispatch]);
  const filteredOrders = orders.filter((order) =>
    selectedStatus === "All"
      ? true
      : String(order.status) === String(selectedStatus)
  );

  const extractLastValidUrl = (url) => {
    const matches = url.match(/https:\/\/moga-dev\.com\/uploads\/[^\s]+/g);
    return matches ? matches[matches.length - 1] : "";
  };

  const handleCancelOrder = (orderId) => {
    dispatch(deleteOrder(orderId))
      .unwrap()
      .then((res) => {
        console.log("order Deleted Successfully", res);
      })
      .catch((err) => {
        console.error("error canceling order", err);
      });
  };
  
  return (
    <div className="w-full flex items-start justify-start ">
      <div className="flex flex-col w-full items-start justify-start ">
        <div className="flex w-full justify-between items-center mb-3">
          <div className="flex items-center justify-center gap-1">
            <h1 className="text-xl"><p className=" text-gray-600">
              {t("showing")}: {selectedStatus === "All" ? t("allOrders") : statusLabels[selectedStatus]}
            </p></h1>
          </div>
          <div className="flex items-center justify-center gap-2">
            <p className="hidden lg:flex">{t("sortBy")} :</p>
            <div className="rounded-full border">
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className={`p-2 rounded-full bg-white text-black 
   border-white text-xs lg:text-base 
  ${isEng ? "border-r-8" : "border-l-8"}`}
              >
                <option value="All">{t("all")}</option>
                {Object.entries(statusLabels).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex w-full h-screen items-center justify-center">
            <MiniLoader />
          </div>
        ) : !Array.isArray(orders) || orders.length === 0 ? (
          <div className="flex flex-col gap-3 items-center justify-center 
          w-full h-full">
            <p className="text-gray-500">
              {t("emptyOrdersLabel")}
            </p>
            <div className="flex flex-col items-center justify-center gap-2">
              <p>{t("emptyOrdersText")}</p>
              <Link to="/products">
                <button className="felx items-center justify-center text-lg 
                rounded-full bg-blue-900 text-white hover:bg-blue-500 
                p-2">
                  {t("shop")}
                </button>
              </Link>
            </div>
          </div>
        ) : error ? (
          <div className="flex items-center justify-center w-full h-full 
          text-red-500">
            {error}
          </div>
        ) : (
          <div className="w-full flex items-center justify-center flex-col 
          gap-3">
            {filteredOrders.length > 0 ? filteredOrders.map((order) => (
              <div
                key={order.id}
                className=" border border-gray-200 rounded-2xl w-full "
              >
                <div
                  className="flex flex-col lg:flex-row lg:justify-between  
                  items-start 
                bg-purble-2 w-full rounded-t-2xl py-2 px-4 text-white"
                >
                  <div
                    className={`flex flex-col items-start justify-center gap-1 
                  border-b  lg:border-b-0 p-2 w-full 
                  ${isEng ? "lg:border-r" : "lg:border-l"}`}
                  >
                    <h1 className="text-pink-2">{t("orderId")}</h1>
                    <h2 className="font-semibold text-lg">#{order.id}</h2>
                  </div>
                  <div
                    className={`flex flex-col items-start justify-center gap-1 
                  border-b  lg:border-b-0 p-2 w-full 
                  ${isEng ? "lg:border-r" : "lg:border-l"}`}
                  >
                    <h1 className="text-pink-2">{t("totalPayment")}</h1>
                    <h2 className="font-semibold text-lg">
                      {order.total_price}{" "}
                      <span className="text-pink-2">{t("currency")}</span>
                    </h2>
                  </div>
                  <div
                    className={`flex flex-col items-start justify-center gap-1 
                  border-b  lg:border-b-0 p-2 w-full 
                  ${isEng ? "lg:border-r" : "lg:border-l"}`}
                  >
                    <h1 className="text-pink-2">{t("paymentMethod")}</h1>
                    <h2 className="font-semibold text-lg">
                      {order.payment_method || "---"}
                    </h2>
                  </div>

                  <div
                    className="flex flex-col items-start justify-center gap-2
                   p-2 w-full "
                  >
                    <h1 className="text-pink-2">{t("orderTime")}</h1>
                    <h2 className="font-semibold text-sm">
                      {order.date || "---"}
                    </h2>
                  </div>
                </div>
                <div className="mt-2 p-3 w-full flex flex-col">
                  {order.items.map((item) => (
                    <div
                      key={item.id}
                      className=" w-full  p-4 mb-4 flex flex-col 
                     items-start gap-2 border-b"
                    >
                      {/* Product Image */}
                      <div className="flex items-start justify-start gap-2 w-full">
                        <div className="w-[4.625rem] h-[4.625rem] rounded-2xl flex-shrink-0">
                          <img
                            src={extractLastValidUrl(
                              item.product?.website_image
                            )}
                            alt={isEng ? item.product?.english_name : item.product?.arabic_name}
                            className=" object-cover rounded-2xl w-[4.625rem] h-[4.625rem]"
                          />
                        </div>
                        {/* product details */}
                        <div className="flex flex-col gap-2 justify-start items-start w-full">
                          <div className="h-[4.625rem] flex flex-col items-start justify-center">
                            {/* product name */}
                            <h3 className="text-lg font-semibold">
                              {isEng ? item.product?.english_name : item.product?.arabic_name}
                            </h3>
                            {/* price & quantity */}
                            <div className="flex items-center justify-center gap-2">
                              <p className="text-gray-600 ">{item.price} {t("currency")}</p>
                              <p className="text-gray-600">* {item.quantity}</p>
                            </div>
                          </div>
                          <div className="w-full flex flex-col justify-start items-start">
                            {/* item addons */}
                            {item.order_item_addons &&
                              item.order_item_addons.length > 0 && (
                                <div className="flex w-full items-start justify-start ">
                                  <div className="w-full flex items-start justify-center flex-col">
                                    <p className="font-medium mb-2 px-4">
                                      Add-ons
                                    </p>
                                    {item.order_item_addons.map((addon) => {
                                      const addonId = addon.addons_id;
                                      const addonName =
                                        isEng ? addon.addon?.english_name : addon.addon?.arabic_name ||
                                        `Add-on #${addonId}`;
                                      const addonPrice = parseFloat(
                                        addon.addon?.price || addon.price || 0
                                      );
                                      const addonQuantity = addon?.quantity;

                                      return (
                                        <div
                                          key={addonId}
                                          className="flex justify-between w-full items-center py-2 px-4 bg-gray-50 rounded-2xl mb-2"
                                        >
                                          <div>
                                            <p>
                                              {addonName} * {addonQuantity}
                                            </p>
                                            <p className="text-sm text-gray-600">
                                              {addonPrice} {t("currency")} {t("each")}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}

                            {/* item message & link */}
                            {item.message && (
                              <div className="mb-4 w-full">
                                <p className="font-medium px-4 mb-2">{t("message")}</p>
                                <div className="mb-2 p-4 bg-gray-50 rounded-2xl">
                                  <p className="text-gray-700">
                                    {item.message}
                                  </p>
                                </div>
                              </div>
                            )}

                            {item.link && (
                              <div className="mb-4 w-full">
                                <p className="font-medium px-4 mb-2">{t("addedLink")}</p>
                                <div className="mb-2 p-4 bg-gray-50 rounded-2xl">
                                  <p className="text-gray-700">{item.link}</p>
                                </div>
                              </div>
                            )}

                            {/* item video */}

                            {(item.uploadvideo ||
                              item.thumbnail ||
                              item.record_video) && (
                                <div className="mb-4">
                                  <p className="font-medium mb-2">
                                    {t("uploadedMedia")}:
                                  </p>
                                  <div className="flex flex-wrap gap-2">
                                    {item.thumbnail && (
                                      <div className="w-24 h-24 relative">
                                        <img
                                          src={item.thumbnail}
                                          alt="Thumbnail"
                                          className="w-full h-full object-cover rounded"
                                        />
                                      </div>
                                    )}
                                    {(item.uploadvideo || item.record_video) && (
                                      <div className="w-24 h-24 relative bg-black flex items-center justify-center rounded">
                                        <span className="text-white text-xs">
                                          {t("video")}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>

                      {/* Product Details */}
                    </div>
                  ))}
                </div>
                <div
                  className="w-full flex flex-col gap-2 lg:items-start  items-center
                lg:justify-start rounded-b-2xl p-4"
                >
                  <div
                    className="w-[85%] lg:w-full flex flex-col lg:flex-row items-center 
                  justify-start gap-2 mb-6"
                  >
                    <div
                      className={`flex items-center justify-center px-2 rounded-full
                    bg-[#F57D0E]/10 border-[#F57D0E] border 
                    text-[#F57D0E] w-[6.1rem] h-[33px]`}
                    >
                      {statusLabels[order.status] || "Unknown"}
                    </div>
                    <div>{t("yourOrderHasBeen")} {statusLabels[order.status] || "Unknown"}</div>
                  </div>
                  <div className="w-full flex-col flex lg:flex-row items-center 
                  justify-between gap-9">
                    <div className="flex flex-col lg:flex-row gap-4">
                      <Link to={`/track-order/${order.id}`}>
                        <button
                          type="button"
                          className="flex items-center justify-center text-lg bg-purble-2
                   text-white hover:bg-blue-500 rounded-full w-[294px] 
                   lg:w-[162px] h-[58px]"
                        >
                          {t("trackOrder")}
                        </button>
                      </Link>
                      <button
                        type="button"
                        className="flex items-center justify-center text-lg bg-white
                   text-blue-2 hover:bg-blue-500 rounded-full w-[294px] lg:w-[162px] 
                   h-[58px] border border-purble-2"
                      >
                        {t("invoice")}
                      </button>
                    </div>
                    <button
                      type="button"
                      className="flex items-center justify-center py-2 px-4
                   text-red-500 hover:underline underline-offset-2"
                      onClick={() => handleCancelOrder(order.id)}
                    >
                      {t("cancelOrder")}
                    </button>
                  </div>
                </div>
              </div>
            )) : <div className="flex flex-col gap-3 items-center justify-center 
          w-full h-screen">
              <p className="text-gray-500">
                {t("noOrderByThatStatus")}
              </p>
            </div>}
          </div>
        )}
      </div>
    </div>
  );
};
export default MyOrders;
